export default __webpack_public_path__ + "static/media/a1.f1a48c70.png";